/* eslint-disable max-len */
import 'react';

let index = 0;

const KnowledgeBookSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const timeStamp = index++;
    const id = `KnowledgeBookSvg-1-${timeStamp}`;
    const id2 = `KnowledgeBookSvg-2-${timeStamp}`;
    const id3 = `KnowledgeBookSvg-3-${timeStamp}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 26 26" {...props}>
            <defs>
                <linearGradient
                    x1="15.244%"
                    y1="0%"
                    x2="84.756%"
                    y2="50%"
                    id={id}
                >
                    <stop stopColor="#FFC56E" offset="0%" />
                    <stop stopColor="#FFB76E" offset="100%" />
                </linearGradient>
                <linearGradient
                    x1="50%"
                    y1="0%"
                    x2="50%"
                    y2="81.112%"
                    id={id2}
                >
                    <stop stopColor="#FFF" stopOpacity={0.96} offset="0%" />
                    <stop stopColor="#FFF" stopOpacity={0.8} offset="100%" />
                </linearGradient>
                <path
                    d="M3.104 0h12.96a4.364 4.364 0 014.365 4.364v15.428a2.494 2.494 0 01-2.494 2.494H4.351a2.494 2.494 0 01-2.494-2.494V1.247C1.857.558 2.415 0 3.104 0z"
                    id={id3}
                />
            </defs>
            <g transform="translate(1.857 2.1)" fill="none" fillRule="evenodd">
                <path d="M0 0h22.286v22.286H0z" />
                <mask id="prefix__c" fill="#fff">
                    <use xlinkHref={`#${id3}`} />
                </mask>
                <use fill="#FFF" opacity={0.8} xlinkHref={`#${id3}`} />
                <path
                    d="M1.857 1.247C1.857.558 2.415 0 3.104 0H15.16a5.278 5.278 0 015.278 5.278v14.514a2.494 2.494 0 01-2.494 2.494H4.351a2.494 2.494 0 01-2.494-2.494V1.247z"
                    fill={`url(#${id})`}
                    mask="url(#prefix__c)"
                />
                <path
                    d="M9.048 11.582a.57.57 0 01.57.57v3.343a.57.57 0 01-.57.569H5.795a.57.57 0 01-.57-.57v-3.342a.57.57 0 01.57-.57h3.253zm7.529 0a.57.57 0 01.57.57v3.343a.57.57 0 01-.57.569h-3.253a.57.57 0 01-.57-.57v-3.342a.57.57 0 01.57-.57h3.253zM12.813 5.18a.57.57 0 01.569.57v3.343a.57.57 0 01-.57.569H9.56a.57.57 0 01-.569-.57V5.75a.57.57 0 01.57-.57h3.253z"
                    fill={`url(#${id2})`}
                    mask="url(#prefix__c)"
                />
            </g>
        </svg>
    );
};
export default KnowledgeBookSvg;
